export const messages = {
  requiredField: "This field is required",
  min: (label: string, value: number) => `${label} must be greater than or equal to ${value}`,
  max: (label: string, value: number) => `${label} must be less than or equal to ${value}`,
};
